import { TDR } from 'tdr-common';
import config from '../common/config';
import Checkout = TDR.CheckoutSession;
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ErrorResponse } from '../common/ErrorResponse';

export const MUTATION_KEY = 'updateCheckoutSession';

export function useUpdateCheckoutItems() {
	const queryClient = useQueryClient();
	const mutation = useMutation({
		mutationKey: [MUTATION_KEY],
		mutationFn: ({ input }: {input: Checkout.UpdateCheckoutItemsInput} ) => updateCheckoutItems(input),
		scope: {
			id: 'updateCheckoutItems'
		},
		onSuccess(data, variables) {
			const checkoutId = variables?.input?.checkoutId;
			if (data?.success && data.updatedInvoice && checkoutId) {
				queryClient.setQueryData(['checkoutSession', checkoutId], (prev: Checkout.CreateCheckoutSessionOutput | undefined) =>
					prev ? { ...prev, checkoutInvoice: data.updatedInvoice } : prev
				);
			}
			queryClient.invalidateQueries({ queryKey: ['checkoutSession'] });
		}
	});

	return mutation;
}

async function updateCheckoutItems(
	input: Checkout.UpdateCheckoutItemsInput
): Promise<Checkout.UpdateCheckoutItemsOutput> {
	const response = await fetch(`${config.apiHost}/updateCheckoutItems`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(input)
	});

	const responsePayload = await response.json() as Checkout.UpdateCheckoutItemsOutput;
	if (!response.ok) {
		throw new ErrorResponse(response, responsePayload);
	}

	return responsePayload;
}
